module.exports = __webpack_public_path__ + "img/impacto-empresas-derechos-humanos-medioambiente.d3ba6b33.png";